import styled from 'styled-components';

const StyledButton = styled.button`
    background: linear-gradient(261deg, rgba(255, 255, 255, 0.00) 63.07%, #FFF 97.25%), radial-gradient(81.05% 180.04% at 50% 169%, rgba(111, 232, 255, 0.00) 0%, #6FE8FF 65%, rgba(111, 232, 255, 0.00) 100%), linear-gradient(90deg, #8FFBD7 0%, #ADFDA5 87.09%);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.20);
    body.dark & {
        box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.20);
    }
`;
export default function PrimaryButton({ className = '', disabled, small = false, children, ...props }) {
    return (
        <StyledButton
            {...props}
            className={
                `${small ? 'px-10 py-2.5 md:py-3' : 'px-8 sm:px-10 py-2.5 sm:py-3 3xl:py-4.5 3xl:text-lg'} user-select-none rounded-md font-semibold primary-button text-black dark:warm-shadow tracking-wide ${
                    disabled && 'opacity-50 dark:opacity-25'
                } ` + className
            }
            disabled={disabled}
        >
            {children}
        </StyledButton>
    );
}
